import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLocalData, setLocalData,removeLocalData } from "../../services/storageManager";
import Constants from "../../utils/constants";
import apiClient from "../../services/apiClient";
import toast from "../../utils/toast";

const initialState = {
    shift: false,
    loading: false,
    error: null,
}

export const changeCheklistStatus = createAsyncThunk(
    'shiftDetails/updateTask',
    async (data, thunkAPI) => {
        let accessToken=JSON.parse(getLocalData('accessToken') || '{}');
        return await apiClient({
            url: `${Constants.API.BASE_URL}${Constants.API.SHIFT_DETAIL.UPDATE_TASK}/${data.checklistId}/${data.itemId}`,
            method: 'POST',
            data: { ...data.bodyData },
            headers:{
                token:accessToken
            }
        }, false).then((data) => data).catch((error) => {
            return thunkAPI.rejectWithValue(error);
        });
    }
)

export const completeShift = createAsyncThunk(
    'shiftDetails/update',
    async (requestData, thunkAPI) => {
        let accessToken= JSON.parse(getLocalData('accessToken') || '{}');
        return await apiClient({
            url: `${Constants.API.BASE_URL}${Constants.API.SHIFT_DETAIL.UPDATE_SHIFT}/${requestData.shiftId}`,
            method: 'POST',
            data: { ...requestData.bodyData },
            headers:{
                token:accessToken
            }
        }, false).then((data) =>{
            setLocalData('showExtraRating', requestData.hasChecklistCompletedWithCommentsAdded);
            return data;
        }).catch((error) => {
            return thunkAPI.rejectWithValue(error);
        });
    }
)

export const getSelectedShiftInfo = createAsyncThunk(
    'getShiftDetail',
    async (data, thunkAPI) => {
        const selectedShiftId = JSON.parse(getLocalData('shift') || '{id:""}').id;
        const accessToken=JSON.parse(getLocalData('accessToken') || '{}');

        return await apiClient({
            url: Constants.API.BASE_URL+Constants.API.SHIFT.GET_ALL + '/' + selectedShiftId,
            method: 'GET',
            headers:{
                token:accessToken
            }
        }, true)
            .then((data) => data.data)
            .catch((error) => {
                return thunkAPI.rejectWithValue(error)
            })
    }
)

const shiftDetailsSlice = createSlice({
    name: 'shiftDetails',
    initialState,
    reducers: {
        clearError(state, action) {
            state.error = null;
        },
        setCurrentShiftData(state, action) {
            state.shift = action.payload;
            setLocalData('shift', JSON.stringify(action.payload));
        },
    },
    extraReducers: (builder) => {
        builder
            /**get shift details */
            .addCase(getSelectedShiftInfo.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getSelectedShiftInfo.fulfilled, (state, action) => {
                state.error = null;
                state.loading = false;
                state.shift = action.payload;
                setLocalData('shift', JSON.stringify(action.payload));
            })
            .addCase(getSelectedShiftInfo.rejected, (state, action) => {
                state.loading = false;
                toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK);
            })
            /**update cheklist */
            .addCase(changeCheklistStatus.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(changeCheklistStatus.fulfilled, (state, action) => {
                state.error = null;
                state.loading = false;
                if (action?.payload?.data?.checklist) {
                    const currentShiftData = JSON.parse(getLocalData('shift') || '[{checklists:[]}]');
                    const updatedCheckLists = currentShiftData?.checklists?.map((chl) => {
                        if (chl.id === action.payload.data.checklist.id) {
                            chl = action.payload.data.checklist;
                        }
                        return chl;
                    })
                    const updatedShift = { ...currentShiftData, ...{ checklists: updatedCheckLists } }
                    state.shift = updatedShift;
                    setLocalData('shift', JSON.stringify(updatedShift));
                }
            })
            .addCase(changeCheklistStatus.rejected, (state, action) => {
                state.loading = false;
                toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK);
            })
            /**end shift */
            .addCase(completeShift.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(completeShift.fulfilled, (state, action) => {
                state.error = null;
                state.loading = false;
                if (action?.payload?.data) {
                    state.shift = action.payload.data;
                    setLocalData('shift', JSON.stringify(action.payload.data));
                }
            })
            .addCase(completeShift.rejected, (state, action) => {
                state.loading = false;
                toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK);
            })
    }
})

export const { clearError, setCurrentShiftData } = shiftDetailsSlice.actions;
export const getLoading = (state) => state.shiftDetails.loading;
export const getError = (state) => state.shiftDetails.error;
export const getShiftDetails = (state) => state?.shiftDetails?.shift || JSON.parse(getLocalData('shift') || '{}');
export const getCheckLists = (state) => state?.shiftDetails?.shift?.checklists || JSON.parse(getLocalData('shift') || '[{checklists:[]}]').checklists;
export const showExtraRating = (state) =>  JSON.parse(getLocalData('showExtraRating')) || 0;
export const hasShiftEnd = (state) => {
    const currentShift = JSON.parse(getLocalData('shift') || "{status:''}");
    if(currentShift?.status?.status.toLowerCase()===Constants.SHIFT.STATUS.CLOSED||currentShift?.status?.status.toLowerCase()===Constants.SHIFT.STATUS.IN_REVIEW){
        return true;
    }
    return false;
}
export const getRating = (state) => {
    const currentShift = JSON.parse(getLocalData('shift') || "{custom_field:[]}");
    const ratingFieldArray = currentShift?.custom_fields.filter((cf) => {
        return cf.id === Constants.RATING_CUSTOM_FIELD.ID;
    });
    return ratingFieldArray[0].value || 0;
}
export const getTaskAssignees = (state) => {
    const currentShift = JSON.parse(getLocalData('shift') || "{custom_field:[]}");
    const assigneesFieldArray = currentShift?.custom_fields.filter((cf) => {
        return cf.name === Constants.CUSTOM_FIELDS.NAME.ASSIGNEE;
    });
    let assignees=assigneesFieldArray.map(value => value?.type_config?.options);
    return assignees?.length?assignees[0]: [];
}
export const getSelectedAssignees = (state) => {
    const currentShift = JSON.parse(getLocalData('shift') || "{custom_field:[]}");
    const assigneesFieldArray = currentShift?.custom_fields.filter((cf) => {
        return cf.name === Constants.CUSTOM_FIELDS.NAME.ASSIGNEE;
    });
    return assigneesFieldArray[0]|| {};
}
export const clearStorage = (state) => {
    removeLocalData('showExtraRating');
    removeLocalData('shift');
    removeLocalData('selectedEmp');
    removeLocalData('selectedDept');

}

export default shiftDetailsSlice.reducer;